import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss']
})
export class NewsDetailsComponent implements OnInit {

  newsListArr: any = [
    {
      id: 101,
      title: 'Participated at ITME 2012',
      description: 'We have successfully participated in ITME 2012, Mumbai between 2-7 December, 2012.',
      image: 'assets/img/news/01.jpg',
      publishDate: 'Dec 07, 2012'
    },
    {
      id: 102,
      title: 'Participated at India Product Show 2014',
      description: 'We have successfully participated in India Product Show 2014, Mandalay-Myanmar between 17-19 January,2014.',
      image: 'assets/img/news/02.jpg',
      publishDate: 'Jan 19, 2014'
    },
    {
      id: 103,
      title: 'Participated at ITMACH India 2014',
      description: 'We have successfully participated in ITMACH 2014, Ahmedabad between 10-13 December, 2014.',
      image: 'assets/img/news/03.jpg',
      publishDate: 'Dec 13, 2014'
    },
    {
      id: 104,
      title: 'Participated at ITME 2016',
      description: 'We have successfully participated in ITME 2016, Mumbai between 3-8 December, 2016.',
      image: 'assets/img/news/04.jpg',
      publishDate: 'Dec 08, 2016'
    },
    {
      id: 105,
      title: 'Participated at ITMACH 2017',
      description: 'We have successfully participated in ITMACH 2017 at Gandhinagar in December, 2017',
      image: 'assets/img/news/05.jpg',
      publishDate: 'Dec 01, 2017'
    },
    {
      id: 106,
      title: 'Participated at ITME 2022',
      description: 'We have successfully Participated in ITME 2022 held at Greater Noida between 8 to 13 December 2022',
      image: 'assets/img/news/06.jpg',
      publishDate: 'Dec 13, 2022'
    },
    {
      id: 107,
      title: 'Participated at Techtextile 2023',
      description: 'We have successfully Participated in Techtextile 2023 held at Jio world Convention Centre between 12 to 14 September 2023',
      image: 'assets/img/news/07.jpg',
      publishDate: 'Sep 14, 2023'
    }
  ]
  currentTab: any = 1;
  currentIndDetail: any = [];
  newsIdCurrent: any;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.paramMap.subscribe(params => {
      this.newsIdCurrent = params.get('newsId');
    });
  }

  ngOnInit() {
    this.currentIndDetail = this.getNewsById(Number(this.newsIdCurrent));
  }

  getNewsById(newsId: number): any {
    return this.newsListArr.find(news => news.id === newsId);
  }

}
